import React, { useEffect, useRef } from 'react';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import MarkerCustomSvg from '../assets/images/icons/marker-icon.svg';

const MapSection = () => {
    const mapContainerRef = useRef(null);
    const mapInstanceRef = useRef(null);

    useEffect(() => {
        if (!mapContainerRef.current) return;

        const map = L.map(mapContainerRef.current, {
            center: [40.706130, -74.009904],
            zoom: 17,
            scrollWheelZoom: false,
            zoomControl: true,
        });
        mapInstanceRef.current = map;

        // https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png
        // https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png
        // https://tile.thunderforest.com/cycle/{z}/{x}/{y}.png
        // https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png
        // https://tiles.stadiamaps.com/tiles/outdoors/{z}/{x}/{y}.png

        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
        }).addTo(map);

        const customIcon = L.icon({
            iconUrl: MarkerCustomSvg,
            iconSize: [25, 41],
            iconAnchor: [19, 50],
            popupAnchor: [-7, -50]
        });

        const marker = L.marker([40.706130, -74.009904], { icon: customIcon }).addTo(map);
        const popupContent = `
        Locked Trade LLC<br/>
        40 Wall St. 28th Floor<br/>
        New York City, NY 10005<br/>
        USA
        `
        marker.bindPopup(popupContent, {
            maxWidth: 400,  // maksymalna szerokość pop-upa w pikselach
            minWidth: 150,
            minHeight: 100,
            maxHeight: 200,
            closeButton: true,
            autoPan: true
        }).openPopup();

        setTimeout(() => {
            map.invalidateSize();
        }, 2000);

        return () => {
            map.remove();
        };
    }, []);

    useEffect(() => {
        const handleResize = () => {
            if (mapInstanceRef.current) {
                mapInstanceRef.current.invalidateSize();
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <section id="map-section">
            <div ref={mapContainerRef} id="map-container" style={{ height: '100%', width: '100%' }}></div>
            <div id="img-container">
                <img src={require('../assets/images/wall-street.jpg')} alt="map" />
            </div>
        </section>
    );
}

export default MapSection;